import { Tag } from 'primereact/tag';
import type { OperatorTaskListItemResponse, OperatorTaskReminderResponse } from '@/core/generated/api';
import { TaskRelatedLinks } from '@/entities/OperatorTask/ui/TaskRelatedLinks';
import { ActionButton } from '@/shared/ui/ActionButton/ActionButton';
import { Section } from '@/shared/ui/Section/Section';
import { formatMoscowDateTime } from '@/shared/lib/dateTime';
import classes from './TaskNotifications.module.scss';

interface OperatorTaskCardProps {
    task: OperatorTaskListItemResponse;
    reminder?: OperatorTaskReminderResponse;
    upcoming?: boolean;
    notification?: boolean;
    busy: boolean;
    disabled?: boolean;
    onOpen: () => void;
    onComplete: () => void;
}

/** Показывает задачу и доступные действия оператора */
export const OperatorTaskCard = (
    { task, reminder, upcoming = false, notification = false, busy, disabled, onOpen, onComplete }: OperatorTaskCardProps
) => (
    <Section className={classes.card}>
        <div className={classes.cardHeader}>
            <Tag
                severity={task.isOverdue
                    ? 'danger'
                    : upcoming
                        ? 'warning'
                        : 'info'
                }
                value={task.isOverdue
                    ? 'Просрочена'
                    : upcoming
                        ? 'Скоро'
                        : task.status?.id === 'completed'
                            ? 'Выполнена'
                            : notification
                                ? 'Напоминание'
                                : task.status?.name ?? 'В работе'
                }
            />
            <small>{task.type?.name}</small>
        </div>
        <button
            type="button"
            className={classes.taskTitle}
            onClick={onOpen}
        >
            № {task.taskNumber} · {task.textPreview}
        </button>
        <p className={task.isOverdue
            ? classes.overdue
            : undefined
        }>Срок: {formatMoscowDateTime(task.dueAtUtc)}</p>
        <p>Ответственный: {task.assignee
            ? [task.assignee.login, task.assignee.role?.name].filter(Boolean).join(' · ')
            : 'Не назначен'}</p>
        {reminder && (
            <div className={classes.reason}>
                <small>Напоминание: {formatMoscowDateTime(reminder.scheduledAtUtc)}</small>
                <span>{reminder.reasons?.map((reason) => reason.name).join(', ')}</span>
                <small>Telegram: {reminder.telegramState?.name ?? '—'}</small>
                {!reminder.isCurrentSchedule &&
                    <small>Событие прежнего расписания</small>
                }
            </div>
        )}
        {!reminder && task.nextReminder &&
            <small>Следующее: {formatMoscowDateTime(task.nextReminder.scheduledAtUtc)}</small>
        }
        <div className={classes.cardActions}>
            <TaskRelatedLinks context={task.context} />
            {task.status?.id === 'inProgress' && (
                <ActionButton
                    label="Выполнено"
                    icon="pi pi-check"
                    outlined
                    permission="admin.operator-tasks.complete"
                    loading={busy}
                    disabled={busy || disabled || !task.id || !task.version}
                    onClick={onComplete}
                />
            )}
        </div>
    </Section>
);
